import React from "react";
import {injectIntl} from "react-intl";
import {EXPECTED, DETECTED, STATUS_COLORS} from "../../../util/Constants";

const PROVISIONING_STATUS_STYLE = (status) => {
    let backgroundColor = "#FFFFFF"; // Default white
    let textColor = "#000000"; // Default black text
    
    if (status === "success") {
        backgroundColor = STATUS_COLORS.SUCCESS.BACKGROUND;
        textColor = STATUS_COLORS.SUCCESS.TEXT;
    } else if (status === "error") {
        backgroundColor = STATUS_COLORS.ERROR.BACKGROUND;
        textColor = STATUS_COLORS.ERROR.TEXT;
    } else if (status === "timeout") {
        backgroundColor = STATUS_COLORS.WARNING.BACKGROUND;
        textColor = STATUS_COLORS.WARNING.TEXT;
    } else if (status === "pending") {
        backgroundColor = STATUS_COLORS.INFO.BACKGROUND;
        textColor = STATUS_COLORS.INFO.TEXT;
    } else if (status === "not-started") {
        backgroundColor = "#FFFFFF" // White
        textColor = "#000000"; // black text
    }
    
    return {
        width: "200px",
        height: "25px",
        textAlign: "center",
        backgroundColor,
        border: "0.5px solid black",
        display: "flex",
        flexDirection: "column", // Stack content vertically
        justifyContent: "center",
        alignItems: "center",
        color: textColor,
        minWidth: "200px", // Ensure consistent width
        boxSizing: "border-box", // Include border in width calculation
        position: "relative", // For tooltip positioning
        cursor: "pointer", // Indicate it's interactive
        fontSize: "11px", // Smaller font to fit more text
        padding: "2px"
    }
}

const CONTAINER_STYLE = {
    position: "relative",
    display: "inline-block",
    "&:hover .tooltip": {
        visibility: "visible",
        opacity: 1
    }
}

/**
 * Component to display provisioning status for an aisle
 */
const ProvisioningStatus = (props) => {
    const {isProvisioned, provisioningData, clusterStatus, visible = true} = props;
    
    // If provisioning is not visible, show an empty cell with the same dimensions
    if (!visible) {
        return (
            <div style={{...PROVISIONING_STATUS_STYLE("none"), visibility: 'hidden'}}>
                {/* Empty cell to maintain layout */}
                <div>&nbsp;</div>
                <div>&nbsp;</div>
            </div>
        );
    }

    // If we don't have any provisioning data yet, show a pending cell
    if (clusterStatus === 'success') {
        if (!provisioningData) {
            return (
                <div style={PROVISIONING_STATUS_STYLE("pending")}>
                    <div style={{fontSize: '12px', marginTop: '2px'}}>In Progress...</div>
                    {/* Show provisioning in progress message when triggered but no status yet */}
                </div>
            );
        }
    } else {
        return (
            <div style={PROVISIONING_STATUS_STYLE("not-started")}>
                <div style={{fontSize: '12px', marginTop: '2px'}}>Not Started</div>
            </div>
        );
    }

    // If we have data, determine the status
    let status;
    let statusText;

    if (isProvisioned) {
        status = "success";
        statusText = `Success`;
    } else {
        status = "error";
        statusText = `${EXPECTED}: ${provisioningData.expectedNodeCount}, ${DETECTED}: ${provisioningData.detectedNodeCount}`;
    }
    
    return (
        <div style={CONTAINER_STYLE}>
            <div style={PROVISIONING_STATUS_STYLE(status)}>
                <div style={{ fontSize: '13px', marginTop: '1px', fontWeight: 'bold' }}>
                    {statusText}
                </div>
            </div>
        </div>
    )
}

export default injectIntl(ProvisioningStatus);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/lidarTester/ProvisioningStatus.js